import { HTTP, authHeader, HTTP_FILE } from './http-service';

class BusinessRegistrationService {
  getCompaniesHouseCompany(companiesHouseNumber) {
    return HTTP.get(`/BusinessRegistration/companies-house/${companiesHouseNumber}`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  search(searchTerm) {
    return HTTP.get(`/BusinessRegistration/search/${searchTerm}`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  create(payload) {
    return HTTP.post('/BusinessRegistration', payload, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  createSoleTrader(payload) {
    return HTTP.post('/BusinessRegistration/sole-trader', payload, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  getByBusinessRegistrationNumber(businessRegistrationNumber) {
    return HTTP.get(`/BusinessRegistration/${businessRegistrationNumber}`, {
      headers: authHeader(),
    }).then((response) => response.data.model);
  }

  update(businessRegistrationNumber, payload) {
    return HTTP.put(`/BusinessRegistration/${businessRegistrationNumber}`, payload, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  getSchemeBusinesses(businessRegistrationNumber) {
    return HTTP.get(`/BusinessRegistration/${businessRegistrationNumber}/scheme-businesses`, {
      headers: authHeader(),
    }).then((response) => response.data.model);
  }

  searchSchemeBusiness(businessRegistrationNumber, schemeId, membershipReference) {
    return HTTP.get(
      `/BusinessRegistration/${businessRegistrationNumber}/scheme-businesses/search`,
      {
        headers: authHeader(),
        params: { schemeId, membershipReference },
      },
    ).then((response) => response.data);
  }

  addSchemeBusiness(businessRegistrationNumber, payload) {
    return HTTP.post(
      `/BusinessRegistration/${businessRegistrationNumber}/scheme-businesses`,
      payload,
      { headers: authHeader() },
    ).then((response) => response.data);
  }

  removeSchemeBusiness(businessRegistrationNumber, schemeId, schemeBusinessId) {
    return HTTP.delete(
      `/BusinessRegistration/${businessRegistrationNumber}/scheme-businesses/${schemeId}/${schemeBusinessId}`,
      { headers: authHeader() },
    ).then((response) => response.data);
  }

  createBusinessRegistrationPerson(businessRegistrationNumber, payload) {
    return HTTP.put(
      `/BusinessRegistration/${businessRegistrationNumber}/business-registration-person`,
      payload,
      {
        headers: authHeader(),
      },
    ).then((response) => response.data);
  }

  updateBusinessRegistrationPerson(
    businessRegistrationNumber,
    businessRegistrationPersonId,
    payload,
  ) {
    return HTTP.put(
      `/BusinessRegistration/${businessRegistrationNumber}/business-registration-person/${businessRegistrationPersonId}`,
      payload,
      {
        headers: authHeader(),
      },
    ).then((response) => response.data);
  }

  removeBusinessRegistrationPerson(businessRegistrationNumber, businessRegistrationPersonId) {
    return HTTP.delete(
      `/BusinessRegistration/${businessRegistrationNumber}/business-registration-person/${businessRegistrationPersonId}`,
      {
        headers: authHeader(),
      },
    ).then((response) => response.data);
  }

  createVerification(businessRegistrationNumber) {
    return HTTP.post(
      '/Verification',
      { businessRegistrationNumber },
      { headers: authHeader() },
    ).then((response) => response.data);
  }

  getVerificationScheduleDate(businessRegistrationNumber) {
    return HTTP.get(`/VerificationSchedule/${encodeURIComponent(businessRegistrationNumber)}`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  getVerification(businessRegistrationNumber) {
    return HTTP.get(`/Verification/${encodeURIComponent(businessRegistrationNumber)}`, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  getVerificationActivityLogs(businessRegistrationNumber) {
    return HTTP.get(
      `/VerificationActivityLog/${encodeURIComponent(businessRegistrationNumber)}`,
      { headers: authHeader() },
    ).then((response) => response.data);
  }

  getCompaniesHouseFile(documentId) {
    return HTTP_FILE.get(`/CompaniesHouseFile/${encodeURIComponent(documentId)}`, {
      headers: authHeader(),
      responseType: 'blob',
    }).then((response) => response.data);
  }
}

export default new BusinessRegistrationService();
